import { Flex } from '@modusign/design-system';
import { useState } from 'react';

import UploadFile from '@app/store/documents/UploadFile';

import UpLoadModalDropZone from '../UpLoadModalDropZone';
import UpLoadModalDropZoneTab, { DropZoneTabUploadType } from '../UpLoadModalDropZoneTab';

interface UpLoadModalCloudDriveProps {
  fileName: string | null;
  onDrop: (acceptFile: Array<File | UploadFile>) => void;
  onReset: () => void;
}

function UpLoadModalCloudDrive({ fileName, onReset, onDrop }: UpLoadModalCloudDriveProps) {
  const [uploadType, setUploadType] = useState<DropZoneTabUploadType>('GOOGLE_DRIVE');

  return (
    <Flex flexDirection="column" width="100%">
      <UpLoadModalDropZoneTab uploadType={uploadType} onClick={setUploadType} />
      <UpLoadModalDropZone
        fileName={fileName}
        uploadType={uploadType}
        onDrop={onDrop}
        onReset={onReset}
      />
    </Flex>
  );
}

export default UpLoadModalCloudDrive;
